import { render, staticRenderFns } from "./addword.vue?vue&type=template&id=353ed264&scoped=true&"
import script from "./addword.vue?vue&type=script&lang=js&"
export * from "./addword.vue?vue&type=script&lang=js&"
import style0 from "./addword.vue?vue&type=style&index=0&id=353ed264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353ed264",
  null
  
)

export default component.exports